import { Box, Modal } from "@mui/material";
import React from "react";
import Close from "../../Components/Icons/Close";
import { makeStyles } from "@mui/styles";
import cssClasses from "./SDRPayment.module.css";
import { useEffect } from "react";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import Button from "../../Subcomponents/Button";
import RupeeIcon from "../../Assets/Images/Sustenance/RupeeIcon.svg";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";

const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const SDRPayment = ({ open, handleClose, allotmentDetails, returnRes }) => {
	const [sdrAmount, setSdrAmount] = useState(0);
	const [enableBtn, setEnableBtn] = useState(false);
	const [helperText, setHelperText] = useState("");
	const classes = useStyles();
	useEffect(() => {
		setSdrAmount(
			(allotmentDetails?.unitCost?.sdr) -
				allotmentDetails?.paidAmt?.sdr >
				500000
				? 500000
				: (allotmentDetails?.unitCost?.sdr) -
						allotmentDetails?.paidAmt?.sdr
		);
		setEnableBtn(true);
	}, [allotmentDetails]);
	function closeModal() {
		handleClose();
	}

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					handleClose();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>SDR Payment</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.cardHeader}>
						<div className={cssClasses.tokenNumWrap}>
							<span>
								{allotmentDetails.unitId.wingId.displayName
									? allotmentDetails.unitId.wingId.displayName
									: allotmentDetails.unitId.wingId.wingName}{" "}
								- {allotmentDetails.unitId.unitNo}{" "}
							</span>
							<span>|</span>
							<span>{allotmentDetails.unitId.projectId.projectName}</span>
						</div>
					</div>
					<div className={cssClasses.cardDetails}>
						<div className={cssClasses.tokenDetails}>
							<div className={cssClasses.tokenData}>
								{allotmentDetails.paymentId && (
									<>
										<span>{allotmentDetails.paymentId?.eventTokenId?.eventId?.title}</span>
										<span>|</span>
									</>
								)}
								<span>{allotmentDetails.unitId.inventoryTypeId.type}</span>
								<span>|</span>
								<span>{allotmentDetails.unitId.floorNo}</span>
								<span>|</span>
								<span>{allotmentDetails.paymentId?.tokenNumber}</span>
								<span>|</span>
								<span>{allotmentDetails.paymentId?.eventTokenId?.tokenId?.name}</span>
							</div>
							<div className={cssClasses.tokenData}>
								<span>Alloted On: </span>
								<span>
									{new Date(allotmentDetails.created_at).toDateString()},{" "}
									{new Date(allotmentDetails.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
								</span>
							</div>
						</div>
					</div>
					<div className={cssClasses.priceBreakDown}>
						<div className={cssClasses.price}>
							<span>Total SDR : </span>
							<span>
								₹
								{numberWithCommas(
									allotmentDetails?.unitCost?.sdr
								)}
							</span>
						</div>
						<div className={cssClasses.paidAmt}>
							<span>SDR Paid: </span>
							<span>₹{numberWithCommas(allotmentDetails?.paidAmt?.sdr)}</span>
						</div>
						<div className={cssClasses.price}>
							<span>SDR Due : </span>
							<span>
								₹
								{numberWithCommas(
									(allotmentDetails?.unitCost?.sdr) -
										allotmentDetails?.paidAmt?.sdr <
										0
										? 0
										: (allotmentDetails?.unitCost?.sdr) - allotmentDetails?.paidAmt?.sdr
								)}
							</span>
						</div>
					</div>
					<div className={cssClasses.amountInputWrap}>
						<CustomInput
							value={sdrAmount}
							label={"Enter amount"}
							mandatory={true}
							inputType={"number"}
							position="start"
							labelText={RupeeIcon}
							image={"true"}
							handleChange={(amt) => {
								setEnableBtn(false);
								amt = amt === "" ? "0" : amt;
								var numbers = /^[0-9]+$/;
								setSdrAmount(parseInt(amt));
								if (
									amt.match(numbers) &&
									parseInt(amt) >= 0 &&
									parseInt(amt) <=
										(allotmentDetails?.unitCost?.sdr) -
											allotmentDetails?.paidAmt?.sdr
								) {
									if (parseInt(amt) > 0 && parseInt(amt) <= 500000) {
										if (
											parseInt(amt) <=
											(allotmentDetails?.unitCost?.sdr) -
												allotmentDetails?.paidAmt?.sdr
										) {
											setEnableBtn(true);
										}
									} else {
										setEnableBtn(false);
									}
								} else {
									setEnableBtn(false);
								}
								if (
									parseInt(amt) > 500000 &&
									(allotmentDetails?.unitCost?.sdr) -
										allotmentDetails?.paidAmt?.sdr >
										500000
								) {
									setHelperText("Payable Amount limit is 500000");
								} else if (
									parseInt(amt) >
									(allotmentDetails?.unitCost?.sdr) -
										allotmentDetails?.paidAmt?.sdr
								) {
									setHelperText(
										`Max. amount to be paid: ₹ ${numberWithCommas(
											(allotmentDetails?.unitCost?.sdr) - allotmentDetails?.paidAmt?.sdr
										)}`
									);
								} else {
									setHelperText("");
								}
							}}
							helperText={helperText}
						/>
						<p style={{ fontStyle: "italic", color: "#667085" }}>
							Max. amount to be paid: ₹{" "}
							{numberWithCommas(
								(allotmentDetails?.unitCost?.sdr) -
									allotmentDetails?.paidAmt?.sdr >
									500000
									? 500000
									: (allotmentDetails?.unitCost?.sdr) - allotmentDetails?.paidAmt?.sdr
							)}
						</p>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<div>
						<Button
							style={{
								color: "#344054",
								backgroundColor: "#ffffff",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							btnName={"Cancel"}
							clicked={() => {
								closeModal();
							}}
						/>
					</div>
					<div>
						<Button
							style={{
								color: "#ffffff",
								backgroundColor: "#155EEF",
								fontSize: "1.6rem",
								lineHeight: "2.4rem",
							}}
							disable={!enableBtn}
							btnName={"Pay Now"}
							clicked={() => {
								returnRes(sdrAmount);
							}}
							//   disable={disabeNext}
						/>
					</div>
				</div>
			</Box>
		</Modal>
	);
};

export default SDRPayment;
